import { Component, OnInit } from '@angular/core';
import { UiService } from '../ui.service';
import { AppServiceService } from '../app-service.service';
import { collectionPost } from '../animation/animate';
import { ActivatedRoute } from '../../../node_modules/@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-custom-order',
  templateUrl: './custom-order.component.html',
  styleUrls: ['./custom-order.component.scss'],
  animations: [collectionPost],
  host: { '[@collectionPost]': '' }
})
export class CustomOrderComponent implements OnInit {
  private ngUnsubscribe: Subject<boolean> = new Subject();
  color:string = '#fff';
  cursorX:any;
  cursorY:any;
  element:any;
  carpet:boolean = false;
  imageScreen:boolean = false;
  post:any;
  public theme:any = {
    'social' : {
      'facebook' : '',
      'instagram': ''
    }
  };
  private img: boolean = true;
  private mobile:boolean = false;
  private fullContent: boolean = false;
  public screen:any = {
    'width' : '1920',
    'height': '1080'
  };

  constructor(
    private app: AppServiceService,
    private route: ActivatedRoute,
    private UI: UiService
  ) { 
    this.cursorX = this.app.cursorX;
    this.cursorY = this.app.cursorY;
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
      this.theme  = data.theme;
    })

    //element post animate 
    this.element = this.app.element;
  }

  showFull(){
    this.fullContent = true;
  }
  smallContent(){
    this.fullContent = false;
  }
  trackByFn(index, song) {
    return index;
  }

  addProp(str:string){
    let regex = new RegExp('%');
    if(!regex.test(str)){
      return str + 'px'
    }
    return str;
  }

  hexToRgb(hex:string) {
    if(!hex){
      return '0,0,0';
    }
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16)
  }

  ngOnInit() {
    //screen
    this.screen = this.app.screen;
    this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.screen = this.app.screen;
    })
    //menu
    this.app.blackStyle.next(true);
    this.app.normalMenu.next(true);
    //left panel
    this.app.showLeftPanel.next(true);
    this.app.transparent.next(true);
    this.app.logoWhite.next(true);
    //this.app.externalButton.next(true); 
    setTimeout(() => {
      this.element = {
        'height': '100%',
        'width': '100%',
        'x': 0,
        'y': 0,
      }
      this.img = false;
    }, 2000);
    setTimeout(() => {
      this.app.title.next(this.post.title);
      this.app.activeMenu.next(true);
      this.app.arrow.next(false);
      this.UI.sliderCollectionPost();
      // if(this.UI.widthMobile()){
      //   this.app.arrow.next(false);
      // }
      this.color = 'transparent';
      //this.UI.activeCarpet();
    }, 2000);

    this.mobile = this.UI.widthMobile();
    this.app.fullImageCollection.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.imageScreen = data;
    })
    setTimeout(() => {
      this.UI.sliderCarpet();
    }, 1000);
  }
  ngOnDestroy(){
    this.app.titleLeftPanel.next(false);
    this.app.activeMenu.next(false);
    this.app.blackStyle.next(false);
    this.app.logoWhite.next(false);
    this.app.submenuState.next('hide');
    this.app.menuState.next('hide');
    this.app.externalButton.next(false); 

    this.app.showLeftPanel.next(false);
    this.app.transparent.next(false);

    setTimeout(() => {
      this.app.title.next('');
    }, 500);

    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}


// WEBPACK FOOTER //
// ./src/app/custom-order/custom-order.component.ts